export enum CharacterAnimations {
  Idle = 'idle',
  Lose = 'lose',
  Win = 'win',
  Win2 = 'win2',
  Nod = 'nod',
  FallAsleep = 'fall_asleep',
  Sleep = 'sleep',
  WakeUp = 'wakeup',
}

export const CHARACTER_ANIMATION_JSON = '/animation/character_animation.json';
export const CHARACTER_ANIMATION_ATLAS = '/animation/character_animation.atlas';
